import React from 'react';
import {BaseFullPage} from '../base';
import {Stack, Typography, useTheme} from '@mui/material';
import {IconBadge} from '../../components';
import {BackButtonProps} from '../base/BackButton';
import {BaseActionButton} from '../base/BaseFullPageActions';
import {useTranslate} from 'hooks';

export const BankIDCallbackPage: React.FC<{
  variant: 'error' | 'success';
  title: string;
  subtitle?: string;
  path: BackButtonProps['path'];
  actions?: BaseActionButton[];
  children?: React.ReactNode;
}> = ({variant, title, subtitle, path, actions, children}) => {
  const theme = useTheme();
  const translate = useTranslate();
  return (
    <BaseFullPage
      id={'connected_account_success'}
      backButton={{
        showCloseIcon: true,
        path: path,
        title: translate('common.close'),
      }}
      actions={actions}>
      <Stack
        minHeight={480}
        direction={'column'}
        spacing={2}
        alignItems={'center'}
        justifyContent={'center'}>
        <IconBadge
          type={'font'}
          icon={variant === 'error' ? 'circle-xmark' : 'circle-check'}
          color={
            variant === 'error'
              ? theme.palette.error.main
              : theme.palette.success.main
          }
          size={'lg'}
        />
        <Typography variant={'h1'} textAlign={'center'}>
          {title}
        </Typography>
        <Typography variant={'body1'} textAlign={'center'}>
          {subtitle}
        </Typography>
        {children}
      </Stack>
    </BaseFullPage>
  );
};
